import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

// Contador animado de 0 al valor objetivo cuando entra en viewport.
export const Counter = ({ value, suffix = "", duration = 2000, testId }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isInView) return;
    let startTime;
    let frame;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * value));
      if (progress < 1) {
        frame = requestAnimationFrame(step);
      } else {
        setCount(value);
      }
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [isInView, value, duration]);

  return (
    <span ref={ref} data-testid={testId}>
      {count.toLocaleString("en-US")}
      {suffix}
    </span>
  );
};

export default Counter;
